import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { openPlaceOrderDialog, openWatchListDialog, openOrderConfirm } from '@/actions/app';
import { stockActions } from '@/actions/trading/stock.action';
import { accountActions } from '@/actions/trading';
import RefreshIcon from '@/assets/images/icons/icon_refresh.png';
import LightRefreshIcon from '@/assets/images/icons/light/icon_refresh.png';
import SearchIcon from '@/assets/images/icons/nav_icon_search.png';
import CloseIcon from '@/assets/images/icons/quote_icon_close.png';
import WatchlistIcon from '@/assets/images/icons/quote_icon_watchlist.png';
import '../../assets/styles/components/instrument/instrument.scss';
import { Icons, SERVICES_RESP } from '@/configurations';
import { APP_LANGUAGE_SUPPORTS, LOADING_TYPE, ORDER_TYPE, REFRESH_DATA } from '@/constants/app';
import { VARIABLES_CONFIGS } from '@/constants/win-vest';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import { Converter, formatFunctions, utilsFunction } from '../../helpers/functions';
import Dropdown from '@/components/Dropdown/Dropdown';
import TabHeader from '@/components/TabHeader/TabHeader';
import Tips from '../Tips/Tips';
import BidAsk from '@/components/Instrument/BidAsk';
import InstrumentIndex from '@/components/Instrument/InstrumentIndex';
import InstrumentProfile from '@/components/Instrument/InstrumentProfile';
import PlaceOrderOption from '../Instrument/PlaceOrderOption';
import InstrumentLightweightCharts from '@/components/@charting/InstrumentLightweightCharts';
import InstrumentECharts from '@/components/@charting/InstrumentECharts'
import { userActions } from '@/actions/user';
import WatchlistAddIcon from '@/assets/images/icons/nav_search_icon_watchlist_normal.png';
import { getElementWidthHeightById } from '@/helpers/global';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { appEnvironment } from '@/configurations/app-configs/app.setting.config'
import { ctrlID } from '@/constants/ctr-id';
import { getSafe } from '@/helpers/global';
import { I_TRADE_ACTION as types } from '@/constants/i-trade';

const QUOTE_TAB = 'quote_tab';
const PROFILE_TAB = 'profile_tab';
const ENABLE_QUOTE = false;

class Instrument extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      tabs: [
        { id: 1, title: 'common_quote' },
        { id: 2, title: 'common_profile' }
      ],
      selectedTab: QUOTE_TAB,
      instrument: {},
      spreadTable: [],
      lastSearchKeyWord: '',
      errorMessage: '',
      errorText:'',
      quoteData: {},
      searchLoading: false,
      transactionData: null,
      isAdd: false,
      chartStyles: null,
      load: true,
      isLoadingQuoteData: false,
      isLoadingConfirm:false,
    }
    this.wlCtrlID = ctrlID.addWlCtrl;
    this.bidAskCtrlID = ctrlID.bidAskCtrl;
  }

  render() {
    const {
      language,
      profile,
      index,
      markets,
      disableClose,
      alert,
      watchlist,
      tradeInformation,
      placeOrder,
      chart,
      pieChart,
      userInfo,
      p_Identifier,
      currentMarket,
      browser, 
      theme 
    } = this.props;

    const {
      tabs,
      selectedTab,
      instrument,
      spreadTable,
      errorMessage,
      errorText,
      quoteData,
      searchLoading,
      transactionData,
      isAdd,
      load,
      chartStyles,
      isLoadingQuoteData,
      isLoadingConfirm,
    } = this.state;

    let enabledWl = false
    let enabledBidAsk = false

    return (
      <React.Fragment>
        <div id="instrument-container" className='instrument-container'>
          {profile &&
            <header>
              <div>
                <TabHeader tabs={tabs} onChange={this.handleChangeTab} />
              </div>
              {!disableClose && <img src={CloseIcon} alt='close_icon' onClick={() => this.props.onClose()} />}
            </header>
          }
          {instrument.updateTime && ENABLE_QUOTE && <section className="last-time">
            <span>{language.common_update}:</span>
            <span>{formatFunctions.dataFormat(instrument.updateTime, dataType.LONG_DATE)}</span>
          </section>}
          {errorMessage
            ? <section>
              <Tips isNoBgColor>
                {errorMessage}
              </Tips>
            </section>
            :
            (searchLoading
              ? <div className='search-loading'>
                <Icons.Loading style={{ width: 50, height: 50, margin: '0 auto' }} />
              </div>
              : <section className="main-information">
                <div className="instrument-name">
                  <span>{instrument.marketID && instrument.instrumentID ? `${instrument.marketID}.${instrument.instrumentID}` : ''}</span>
                  <span>{this.stockName(instrument)}</span>
                </div>
                {
                  ENABLE_QUOTE && <div className={classnames('instrument-price', quoteData.classStyle)}>
                    {isLoadingQuoteData
                      ? <Icons.Loading />
                      : <React.Fragment>
                        <div className="current pointer"
                          onClick={() => this.copyPrice(quoteData.last)}>{quoteData.last, '-'}</div>
                        <div className="change-number">{quoteData.changeValue}</div>
                        <div className="change-percent">{quoteData.changePercent}</div>
                      </React.Fragment>
                    }
                    {
                      enabledWl && userInfo['id'] && <div className="flex-box">
                        <div className="add-btn"
                          onClick={() => this.openWatchlistDialog(isAdd ? VARIABLES_CONFIGS.DELETE : VARIABLES_CONFIGS.ADD)}
                          style={{ backgroundColor: isAdd ? '' : '#424F5F' }}>
                          <LoadingLayer load={load} type={LOADING_TYPE.SMALL_IMG} />
                          <img src={isAdd ? WatchlistIcon : WatchlistAddIcon} alt='watchlist_icon' />
                          {isAdd ? '' : <b>{language.watchlist_title}</b>}
                        </div>
                      </div>
                    }
                  </div>
                }

              </section>
            )
          }
          <section className="search-input">
            <div className="market">
              <Dropdown
                style={{ height: '100%' }}
                selectedOptions={[markets.filter(v => v.value === currentMarket)[0]]}
                options={markets}
                innerRef={e => this.marketRef = e}
                onChange={this.handleChangeMarket}
              />
            </div>
            <div className="name">
              <img src={SearchIcon} alt='search_icon' onClick={() => this.handleSearchInstrument()} />
              <input
                type="text"
                ref={e => this.instrumentInputRef = e}
                onBlur={() => {
                  this.handleSearchInstrument()
                }}
                onKeyDown={this.handleInputKeyDown} />
              <img src={ (browser === 'ie' && theme==='light') ? LightRefreshIcon : RefreshIcon } alt='refresh_icon' onClick={this.handleRefresh} />
            </div>
          </section>
          {selectedTab === QUOTE_TAB &&
            <React.Fragment>
              {index && <section>
                <InstrumentIndex />
              </section>}
              {enabledBidAsk && <section style={{ marginTop: 10 }}>
                <BidAsk />
              </section>}
              {placeOrder &&
                <section style={{ marginTop: 10 }}>
                  <PlaceOrderOption
                    innerRef={e => this.placeOrderOptionRef = e}
                    tradeInformation={tradeInformation}
                    spreadTable={spreadTable}
                    lotSize={instrument.lotsize}
                    showGrossAmount
                    openGTDByTab
                    currencyID={instrument.currencyID}
                  />
                </section>}
              <section id="chart-section">
                {(chart && chartStyles) && <InstrumentLightweightCharts
                  chart_id={'instrument-small-chart'}
                  rangeSwitcherEnabled={false}
                  isMinimize={true}
                  styles={chartStyles}
                  cHeight={200}
                  volumeEnabled={false}
                  onMaximize={() => this.props.toggleChart()} />}
              </section>
              { errorText && <Tips isNoBgColor>{errorText}</Tips>}
              {pieChart && transactionData && !chart &&
                <InstrumentECharts innerRef={e => this.EChartsRef = e} data={transactionData} />}
              <section className='buy-sell-action'>
                <button className='buy-btn'
                  onClick={() => this.handleOpenPlaceOrderDialog(true)}>{language.common_buy}</button>
                <button className='sell-btn'
                  onClick={() => this.handleOpenPlaceOrderDialog(false)}>{isLoadingConfirm ? <Icons.Loading /> : language.common_sell}</button>
              </section>
            </React.Fragment>}
          {selectedTab === PROFILE_TAB && <InstrumentProfile />}
        </div>
      </React.Fragment>
    )
  }

  getMarket = () => {
    this.marketRef.setValue([this.props.markets.filter(v => v.value === this.props.currentMarket)[0]]);
    const tradeConfig = this.props.tradeConfigSettings
    this.setState({
      instrument: {},
      lastSearchKeyWord: ''
    }, () => {
      this.instrumentInputRef.value = '';
      this.props.changeMarket(this.props.currentMarket, this.props.tradeDateInfoList, tradeConfig)
    })
  }

  copyPrice = (price) => {
    if (this.props.profile) return
    this.placeOrderOptionRef.setPrice(price);
    this.placeOrderOptionRef.handleChangePrice(price)
    this.placeOrderOptionRef.focusPrice();
  }

  handleRefresh = () => {
    this.handleSearchInstrument(true)
  }

  handleChangeMarket = (market) => {
    if (market.length > 0) {
      const tradeConfig = this.props.tradeConfigSettings
      const marketID = market[0].value
      this.setState({
        instrument: {},
        lastSearchKeyWord: ''
      }, () => {
        this.instrumentInputRef.value = '';
        this.instrumentInputRef.focus();
        this.props.changeMarket(marketID, this.props.tradeDateInfoList, tradeConfig)
      })
    }
  }

  stockName(instrument) {
    const { language } = this.props
    switch (language.lang) {
      case APP_LANGUAGE_SUPPORTS[0].id: {
        return instrument['instrumentChineseName']
      }
      case APP_LANGUAGE_SUPPORTS[1].id: {
        return instrument['instrumentChineseName']
      }
      default: {
        return instrument['instrumentName']
      }
    }
  }

  handleGetSpreadTable(spreadTableCode) {
    const { language } = this.props;
    const params = {
      [PARAMS.SPREAD_TABLE_CODE]: spreadTableCode,
      [PARAMS.LANGUAGE]: language.lang
    }
    this.props.getSpreadTable(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          this.setState({ spreadTable: res.result.spreadTableList })
        }
      }
    })
  }

  handleSearchInstrument = (isRefresh = false, noReset = false) => {
    this.setState({ errorMessage: '',errorText:'' })
    const { language, currentMarket, userInfo } = this.props;
    const { id } = userInfo;
    let keyword = this.instrumentInputRef.value;

    if (keyword === '') {
      this.setState({ errorMessage: language['instrument_required'] })
    }

    if (isRefresh || (keyword && keyword !== this.state.lastSearchKeyWord)) {
      this.setState({ searchLoading: false })
      const params = {
        [PARAMS.MARKET_ID]: currentMarket,
        [PARAMS.INSTRUMENT_ID]: utilsFunction.instrumentIDFunction(keyword,currentMarket),
        [PARAMS.LANGUAGE]: language.lang
      }
      this.props.getInstrumentDetail(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ instrument: res.result, lastSearchKeyWord: res.result.instrumentID });
            this.instrumentInputRef.value = res.result.instrumentID;
            if (!noReset) {
              if (this.placeOrderOptionRef) this.placeOrderOptionRef.reset();
            }
            this.handleGetSpreadTable(res.result.spreadTableCode);
            this.setState({ isLoadingQuoteData: true })
            if (ENABLE_QUOTE) {
              this.props.getQuote({ exchangeID: currentMarket, instrumentID: res.result.instrumentID }, res => {
                const quoteData = Converter.computeQuoteData(res);
                this.setState({ quoteData, isLoadingQuoteData: false, searchLoading: false }, () => {
                  if (id && ENABLE_QUOTE) {
                    this.getQuoteHistory({ stockCode: this.instrumentInputRef.value, marketID: currentMarket })
                  }
                })
              })
              this.onChartPrepare();
            }
            this.placeOrderOptionRef.focusPrice()
          } else {
            this.setState({ errorMessage: res.result.errorMessage, searchLoading: false })
          }
        }
      })
    }
  }

  handleInputKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.handleSearchInstrument();
    }
  }

  getQuoteHistory(params) {
    if (params) {
      let data = [];
      let quoteHistoryData = [];
      let stop = ''
      this.props.getQuoteHistory('', res => {
        if (res.length !== 0) {
          quoteHistoryData = res;
          quoteHistoryData.map(item => {
            data.push(item.market_id + ':' + item.id)
            if (item.id === params.stockCode) {
              stop = true
              return
            }
          })
        }
        if (!stop) {
          data.push(params.marketID + ':' + params.stockCode)
          this.props.manageQuoteHistory({ ids: JSON.stringify(data).replace(/\"/g, '').replace(/\[|]/g, '') }, res => {
          })
        }
      })
    }
  }

  getTradeDistributionData = () => {
    if (!ENABLE_QUOTE) return
    const { marketParams, language } = this.props;
    const { marketID, stockCode } = marketParams;
    let params = {
      symbols: [
        {
          exchangeID: Converter.mappingWebSocketMarket(marketID),
          key: Converter.mappingStockCode(stockCode)
        }
      ]
    }
    this.props.getTradeDistribution(params, res => {
      if (res.bullUltraBlock) {
        const { transactionData } = this.state;
        let ResData = [
          { value: res.bullUltraBlock.turnover, name: this.props.language.market_bull_ultra_block, bgColor: '#3B6953' },
          { value: res.bullBlock.turnover, name: this.props.language.market_bull_block, bgColor: '#478A5E' },
          { value: res.bullRetail.turnover, name: this.props.language.market_bull_retail, bgColor: '#5BA452' },
          { value: res.bearRetail.turnover, name: this.props.language.market_bear_retail, bgColor: '#D75153' },
          { value: res.bearBlock.turnover, name: this.props.language.market_bear_block, bgColor: '#B00A32' },
          { value: res.bearUltraBlock.turnover, name: this.props.language.market_bear_ultra_block, bgColor: '#AF2D30' },
        ]

        if (transactionData && this.EChartsRef) {
          this.EChartsRef.setEChartPieData({
            series: [{
              name: language.market_distribution_title,
              data: ResData
            }]
          })

        } else {
          this.setState({
            transactionData: ResData
          })
        }
      }
    })
  }

  handleOpenPlaceOrderDialog = async(direction) => {
    const { currentTradingAccount,currentMarket } = this.props;
    if (!this.state.errorMessage) {
      let options = '', orderData = {};
      if (this.placeOrderOptionRef) {
        options = this.placeOrderOptionRef.getOptions();
        const stopPrice = options.stopPrice ?? '0'
        if (options.price === '0' || options.quantity === '0' ||
          (options.orderType.value === ORDER_TYPE.TRIGGER_ORDER.value && stopPrice === '0')) {
          this.placeOrderOptionRef.validateInput();
          return;
        }
        if(!(options.quantity % this.state.instrument.lotsize == 0) && (currentMarket !== 'SZMK' && currentMarket !== 'MAMK') && !direction){
          this.setState({ errorText:this.props.language.HKSFOE00021.format(this.state.instrument.lotsize) })
          return;
        } else if(direction && !(options.quantity % this.state.instrument.lotsize == 0)){
          this.setState({ errorText:this.props.language.HKSFOE00021.format(this.state.instrument.lotsize) })
          return;
        } else if (!direction){
          let qty = parseInt(options.quantity)
          await this.getAvailableQuantity(qty);
        }else{
          this.setState({
            errorText:''
          })
        }
        orderData = {
          ...this.state.instrument,
          ...options,
          spreadTable: this.state.spreadTable,
          quoteData: this.state.quoteData
        }
      } else {
        orderData = {
          ...this.state.instrument,
          spreadTable: this.state.spreadTable,
          quoteData: this.state.quoteData
        }
      }
      if(this.state.errorText){
        return
      }
      if(this.props.TradeDashboard){
        orderData.isBuy = direction
        orderData.cashAccount = currentTradingAccount.clientID
        openOrderConfirm(orderData, (isCloseDialog = true) => {
        })
      }else{
        openPlaceOrderDialog(direction, orderData)
      }
    }
  }

  getAvailableQuantity = (qty) => {
    return new Promise(resolve => {
      this.setState({ isLoadingConfirm: true })
      const { language, currentTradingAccount, currentMarket } = this.props;
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.MARKET_ID]: currentMarket,
        [PARAMS.INSTRUMENT_ID]: this.instrumentInputRef.value,
        [PARAMS.LANGUAGE]: language.lang
      }
      this.props.getAvailableQuantity(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            if (res.result.avaiableQuantity == 0) {
              this.setState({ errorText: language.error_message_available_qty_zero})
            } else if (qty > res.result.avaiableQuantity) {
              this.setState({ errorText: language.error_message_more_than_available_qty})
            } else {
              this.setState({
                errorText: ''
              })
            }
          }
        }
        this.setState({ isLoadingConfirm: false })
        resolve()
      })
    })
  }

  handleChangeTab = (tab) => {
    switch (tab.main.title) {
      case 'common_quote': {
        this.setState({ selectedTab: QUOTE_TAB })
        break;
      }
      case 'common_profile': {
        this.setState({ selectedTab: PROFILE_TAB })
        break;
      }
      default:
        break;
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }

  componentDidMount() {
    this.instrumentInputRef.value = this.props.marketParams.stockCode ? this.props.marketParams.stockCode : '';
    if (this.instrumentInputRef.value && this.instrumentInputRef.value !== '') {
      this.handleSearchInstrument();
    }
    this.getTradeDistributionData();
    if (this.props.chart) {
      this.onChartPrepare();
    }
    if (this.props.userInfo) {
      this.setState({
        load: false
      })
    }
    if(this.props.markets && this.props.markets.length > 0) {
      const tradeConfig = this.props.tradeConfigSettings
      const marketID = this.props.markets[0].value
      this.props.changeMarket(marketID, this.props.tradeDateInfoList, tradeConfig)
    }
  }

  componentDidUpdate(preProps) {
    const { isNeedRefresh, marketParams, currentMarket, language, chart, userInfo, watchlistData } = this.props;
    if (marketParams && preProps.marketParams.stockCode !== marketParams.stockCode) {
      this.getTradeDistributionData();
      this.isAdd()
      let stockCode = utilsFunction.instrumentIDZeroPadding(this.props.marketParams.stockCode ? this.props.marketParams.stockCode : '1')
      this.instrumentInputRef.value = stockCode;
      this.handleSearchInstrument(false, true)
    }
    if (chart !== preProps.chart) {
      this.onChartPrepare();
      this.getWatchlistData()
    }
    if (userInfo && preProps.userInfo !== userInfo) {
      this.setState({
        load: false
      })
      this.getWatchlistData()
    }
    if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
      this.props.toggleRefreshMarket(false);
    }
    if (watchlistData && preProps.watchlistData !== watchlistData) {
      this.isAdd();
    }
    if (currentMarket && preProps.currentMarket !== currentMarket) {
      this.getMarket();
      this.handleSearchInstrument(false, false)
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }

  getWatchlistData() {
    const { marketParams, userInfo } = this.props;
    const { id } = userInfo;
    if (id) {
      this.props.getWatchlist({ uuid: id }, res => {
        this.isAdd()
      })
    }
  }

  isAdd = () => {
    const { watchlistData, marketParams } = this.props;
    const { stockCode, marketID } = marketParams;
    let stop = '';
    watchlistData.map(item => {
      if (item.id === stockCode && item.market === marketID) {
        stop = true
        return
      }
    })
    if (stop) {
      this.setState({
        isAdd: true
      })
    } else {
      this.setState({
        isAdd: false
      })
    }
  }

  openWatchlistDialog = (action) => {
    if (this.state.load) return
    openWatchListDialog(action)
  }

  onChartPrepare = () => {
    const pDivWH = getElementWidthHeightById('instrument-container');
    let chartWH = {
      width: pDivWH.width - 30,
      height: 320
    }
    this.setState({
      chartStyles: chartWH
    })
  }
}

Instrument.defaultProps = {
  profile: null,
  index: false,
  disableClose: false,
  alert: null,
  watchlist: null,
  tradeInformation: null,
  placeOrder: true,
  chart: null,
  pieChart: false,
  p_Identifier: null,
  TradeDashboard:false
}

export default connect(
  state => ({
    language: state.app.language,
    currentMarket: state.trade.currentMarket,
    markets: state.trade.markets,
    marketParams: state.trade.marketParams,
    userInfo: state.user.userInfo,
    isNeedRefresh: state.refresh.marketAction,
    watchlistData: state.watchlist.watchlist,
    tradeConfigSettings: state.trade.tradeConfigSettings,
    orderTypes: state.trade.orderTypes,
    tradeDateInfoList: state.trade.tradeDateInfoList,
    currentTradingAccount: state.trade.currentTradingAccount,
    browser:state.app.browser,
    theme:state.app.theme
  }),
  dispatch => ({
    getInstrumentDetail: (p, res) => dispatch(stockActions.getInstrumentDetailAction(p, res)),
    getSpreadTable: (p, res) => dispatch(stockActions.getSpreadTableAction(p, res)),
    getQuote: (p, res) => stockActions.enquireInstrumentInfoAction(p, res),
    setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
    getTradeDistribution: (p, res) => dispatch(stockActions.getTradeDistributionAction(p, res)),
    getWatchlist: (p, res) => dispatch(userActions.getWatchlistAction(p, res)),
    getQuoteHistory: (p, c) => dispatch(userActions.getQuoteHistoryAction(p, c)),
    manageQuoteHistory: (p, res) => dispatch(userActions.manageQuoteHistoryAction(p, res)),
    toggleRefreshMarket: (p) => dispatch({
      type: REFRESH_DATA.MARKET_ACTION,
      value: p
    }),
    changeMarket: (p, p2, res) => dispatch(stockActions.changeMarketAction(p, p2, res)),
    getAvailableQuantity: (p, res) => dispatch(accountActions.getAvailableQuantityAction(p, res))
  })
)(Instrument)
